import Identity from '../identity';
import LoginCallback from '../welcome/loginRedirection';
import PendingNonBiometricSession2 from '../identity/PendingNonBiometricSession2';

const routes = [
  {
    path: '/dashboard',
    element: <LoginCallback />,
    exact: true,
  },
  {
    path: '/',
    element: <Identity />,
    exact: true,
  },
  {
    path: '/verification-pending',
    element: <PendingNonBiometricSession2 />,
    exact: true,
  }
  // {
  //   path: '/unauthorized',
  //   element: <ErrorPage type="unauthorized" />,
  // },
  // {
  //   path: '/server-error',
  //   element: <ErrorPage type="serverError" />,
  // },
];

export default routes;
